import React from 'react'
import { IconAudio, IconStopAudio } from '../../icons/library'
import { Button, ButtonShape, ButtonStyle } from '../simple/button'

interface AudioButtonProps {
  url: string
}

/**
 * AudioButton component is a button that plays an audio file when clicked.
 * @param {string} url - The URL of the audio file to play.
 */
export const AudioButton: React.FC<AudioButtonProps> = ({ url }) => {
  const [playing, setPlaying] = React.useState(false)
  const audioRef = React.useRef<HTMLAudioElement>(null)

  const togglePlay = () => {
    if (playing) {
      audioRef.current?.pause()
    } else {
      audioRef.current?.play()
    }
    setPlaying(!playing)
  }

  return (
    <Button onClick={togglePlay} shape={ButtonShape.iconCircleSmall} buttonStyle={ButtonStyle.light}>
      {playing ? <IconStopAudio /> : <IconAudio />}
      <audio hidden ref={audioRef} src={url} onEnded={() => setPlaying(false)} />
    </Button>
  )
}
